import { useConfig } from '@/hooks'
import React from 'react'
import Tag from '../Tag'
import style from './styles/books.module.scss'

interface IProps {
  image: string
  tag: string | null
  title: string
  link: string
  id: number
}

const BooksCard = ({ image, tag, title, link, id }: IProps): React.ReactElement => {
  const config = useConfig()
  const whatRead = config.what_read
  return (
    <a
      href={link === null ? `${whatRead}?element_id=${id}` : link}
      target={link === null ? '_self' : '_blank'}
      rel='nofollow noopener noreferrer'
      className={style.books__link}
    >
      <img
        src={image}
        width='270px'
        height='382'
        alt={tag !== null ? tag : 'Обложка'}
        className={style.books__image}
      />
      <div className={style.books_content}>
        {tag !== null
          ? (
            <Tag title={tag} theme='blue' className={style.books__tag} />

            )
          : null}
        <p className={style.books__title}>{title}</p>
      </div>
    </a>
  )
}

export default BooksCard
